export enum CampaignTypes {
  CONTENT = 'content'
}

export enum CampaignStatus {
  DRAFT = 'draft',
  IN_PROGRESS = 'in-progress',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled'
}

export enum CampaignTarget {
  LINK_BUILDING = 'link_building',
  BRANDING = 'branding',
  OTHER = 'other'
}

export interface BasicCampaignResourceModel {
  id: number
  title: string | null
  status: string
  campaign_code: string | null
  company: any | null
  url?: string
}